<template>
    <div
        id="menu"
        :class="{ collapsed: !isMenuOpen, 'force-hidden': isForcedHidden }"
        @click="handleMenuContainerClick"
    >
        <button
            v-if="!isMenuOpen && !isForcedHidden"
            class="menu-open-hint"
            type="button"
            title="Abrir menu lateral"
            aria-label="Abrir menu lateral"
            @click.stop="openMenuByClick"
        >
            <i class="fas fa-angle-right"></i>
        </button>

        <div id="menu-header">
            <div class="logo-container-container">
                <div class="logo-container">
                    <div class="logo"></div>
                </div>
            </div>
            <img class="logotipo" :src="logoPath" />
        </div>
        <div id="menu-screen-list">
            <div v-for="screen in screens" v-bind:key="screen.menuKey"  class="button" @click="redirect(screen)"
            :class="{'active': screen.menuKey === currentActiveMenuKey}">
                <div class="button-content">
                    <div v-if="typeof screen.menuLogo == 'string'" class="button-icon">
                        <i class="fas" :class="'fa-'+screen.menuLogo"></i>
                    </div>
                    <div v-else-if="Array.isArray(screen.menuLogo)" class="button-icon"
                        style="display: flex; justify-content: space-evenly; max-width: 70%; margin:auto"
                    >
                        <i v-for="(icon, index) in screen.menuLogo" v-bind:key="index" 
                            class="fas" :class="'fa-'+icon"
                            
                            >
                        </i>
                    </div>
                    <div class="button-label">{{t(screen.label)}}</div>
                </div>
            </div>
        </div>
        <div id="menu-footer">
            <div v-for="action  in footerActions" 
                v-bind:key="action.name" 
                class="button"
                @click="onClickHandler(action.onClick)">
                <i class="icon fas" :class="'fa-'+action.logo"></i>
                {{action.label}}
            </div>
        </div>
        <img class="poweredBy" src="../../../static/desenvolvidoTeknisa.svg" />
        <button
            v-if="isMenuOpen"
            class="menu-toggle"
            type="button"
            title="Fechar menu lateral"
            aria-label="Fechar menu lateral"
            @click.stop="closeMenu"
        >
            <i class="fas fa-angle-left"></i>
        </button>
        <div class="app-version">v {{ appVersion }}</div>
    </div>
</template>

<script>
import LoginService from '@/application/services/Login'
import permissionManager from '@/application/libs/permissionManager'
import { t } from 'i18next'
// import ProdENV from '../../../config/prod.env.js';

export default {
    name:"MenuComponent",
    data(){
        return {
            // screenList: this.$router.options.routes.filter(route=>route.showOnMenu),
            footerActions: [
                {
                    name:"logout",
                    label:t('leave'),
                    logo:"power-off",
                    onClick: this.doLogout
                }
            ],
            activeScreen: null,
            appVersion: process.env.APP_VERSION || '1.0.0',
            isMenuPinned: true,
            isMenuExpanded: false,
            isForcedHidden: false,
            hasManualMenuPreference: false,
            desktopBreakpoint: 1440
        }
    },
    computed: {
        screens: function(){
            const permissions = permissionManager.getMenuAccess();
            return this.$router.options.routes.filter(route => route.showOnMenu && permissions[route.path]);
        },
		currentActiveMenuKey() {
			const currentPath = this.$route?.path;
			const routeEntry = this.$router.options.routes.find((route) => route.path === currentPath);

			if (routeEntry && routeEntry.menuKey) {
				return routeEntry.menuKey;
			}

			return String(currentPath || '').replace('/', '');
		},
		logoPath() {
	   	if (localStorage.getItem('lang') === 'es-CL') {
	      	return "@/../static/bo-logotipo-es.png";
	      } else if(localStorage.getItem('lang') === 'en-US') {
	        return "@/../static/bo-logotipo-en.png";
	      }else{
	      	return "@/../static/bo-logotipo-pt.png";
	      }
	   },
        isMenuOpen(){
            return this.isMenuPinned || this.isMenuExpanded;
        }
    },
    watch: {
        isMenuOpen(){
            this.emitMenuWidth();
        }
    },
    methods:{
        emitMenuWidth(){
            const menuWidth = this.isForcedHidden ? 0 : (this.isMenuOpen ? 100 : 34);
            this.$emit('menu-width-change', menuWidth);

            const appRoot = document.getElementById('app');
            if(appRoot){
                appRoot.style.setProperty('--menu-width', `${menuWidth}px`);
            }
        },
        toggleMenu(){
            if(this.isMenuPinned){
                this.isMenuPinned = false;
                this.isMenuExpanded = false;
            }else{
                this.isMenuPinned = true;
                this.isMenuExpanded = true;
            }
            this.hasManualMenuPreference = true;
            localStorage.setItem('optimizerMenuPinned', this.isMenuPinned ? '1' : '0');
            localStorage.setItem('optimizerMenuExpanded', this.isMenuExpanded ? '1' : '0');
        },
        closeMenu(){
            this.isMenuPinned = false;
            this.isMenuExpanded = false;
            this.hasManualMenuPreference = true;
            localStorage.setItem('optimizerMenuPinned', '0');
            localStorage.setItem('optimizerMenuExpanded', '0');
        },
        openMenuByClick(){
            if(!this.isMenuOpen){
                this.isMenuExpanded = true;
                this.hasManualMenuPreference = true;
                localStorage.setItem('optimizerMenuExpanded', '1');
            }
        },
        handleMenuContainerClick(){
            if(this.isForcedHidden){
                return;
            }
            if(!this.isMenuOpen){
                this.openMenuByClick();
            }
        },
        handleGridFocusEvent(event){
            this.isForcedHidden = Boolean(event && event.detail && event.detail.hideMenu);
            this.emitMenuWidth();
        },
        applyResponsiveDefault(){
            if(this.hasManualMenuPreference){
                return;
            }

            this.isMenuPinned = window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`).matches;
            this.isMenuExpanded = false;
        },
        redirect: function(screen){
            if(this.$router.currentRoute.path!=screen.path){
                localStorage.setItem('activeScreen', screen.menuKey);
                this.$router.push(screen.path);
            }else{
                window.location.reload();
            }
        },
        onClickHandler(onClick){
            if(onClick){
                onClick(this);
            }
        },
        doLogout(){
            this.$modal.show({
                template:`
                    <div class="confirmation-dialog-box">
                        <h5 class="title">{{$t('changes_may_be_not_saved')}}<br>{{$t('do_you_really_want_to_leave')}}</h5>
                        
                        <div class="dialog-button-container">
                            <button class="confirmation-dialog-button" @click="close"> {{$t('cancel')}} </button>
                            <button class="confirmation-dialog-button" @click="logout"> {{$t('leave')}} </button>
                        </div>
                    </div>
                `,
                methods:{
                    logout(){
                        LoginService.doLogout(this);
                    },
                    close(){
                        this.$emit('close');
                    }
                }
            }, {}, {
                //Modal properties
                height:'150px',
                width:'400px',
                resizable:false
            })
        },
        t(value) {
            return t(value);
        }
    },
    mounted(){
        const storedMenuPinned = localStorage.getItem('optimizerMenuPinned');
        const storedMenuExpanded = localStorage.getItem('optimizerMenuExpanded');
        this.hasManualMenuPreference = storedMenuPinned !== null || storedMenuExpanded !== null;

        if(this.hasManualMenuPreference){
            if(storedMenuPinned !== null){
                this.isMenuPinned = storedMenuPinned !== '0';
            } else {
                this.isMenuPinned = false;
            }
            this.isMenuExpanded = storedMenuExpanded === '1';
        } else {
            this.applyResponsiveDefault();
        }

        this.activeScreen = this.currentActiveMenuKey;
        this.emitMenuWidth();
        window.addEventListener('optimizer:grid-focus', this.handleGridFocusEvent);
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.applyResponsiveDefault);
        window.removeEventListener('optimizer:grid-focus', this.handleGridFocusEvent);
    }
}
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

#menu {
    .user-not-select;
    position: relative;
    background: linear-gradient(180deg, #24244f 0%, #1b1b3d 100%);
    max-width: 100px;
    height: 100vh;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.18);
    transition: max-width 0.2s ease;
    overflow: visible;

    &.collapsed {
        max-width: 34px;

        #menu-header,
        #menu-screen-list,
        #menu-footer,
        .poweredBy,
        .app-version {
            opacity: 0;
            pointer-events: none;
        }
    }

    &.force-hidden {
        max-width: 0;
        min-width: 0;
        box-shadow: none;
        overflow: hidden;
        pointer-events: none;
    }

    .menu-toggle svg{
        transform: rotate(180deg);
    } 

    .menu-toggle {
        position: absolute;
        bottom: 90px;
        left: 50%;
        transform: translateX(-50%);
        width: 40px;
        height: 20px;
        border-radius: 999px;
        border: 0;
        background: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 30;
        transition: background-color 0.16s ease, transform 0.16s ease;

        i {
            color: #ffffff;
            font-size: 1rem;
            line-height: 1;
        }

        &:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateX(-50%) scale(1.03);
        }
    }

    .menu-open-hint {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 0;
        background: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        width: 20px;
        height: 44px;
        cursor: pointer;
        border-radius: 999px;
        z-index: 35;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.16s ease, transform 0.16s ease;

        i {
            font-size: 1rem;
        }

        &:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translate(-50%, -50%) scale(1.03);
        }
    }

    #menu-header {
        transition: opacity 0.14s ease;
        margin-top: 15px;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0;

        * {
            margin: 1px;
        }

        .logo-container-container {
            height: 65px;
            .logo-container {
                .logo {
                    position: relative;
                    display: table;
                    width: 50px;
                    height: 50px;
                    background: url('../../../static/bo-icone.svg') center center;
                    background-size: contain;
                }
            }
        }

        .logotipo {
            max-width: 85%;
            display: inline-block;
            vertical-align: middle;
            filter: drop-shadow(-2px 4px 6px black);
            margin-bottom: 5px; /* Reduz espaço abaixo da logo */
        }

        h4 {
            display: inline-block;
            vertical-align: middle;
            font-size: 0.85rem;
            color: white;
            text-shadow: -2px 4px 6px black;
        }
    }

    #menu-screen-list {
        height: calc(100vh - 214px); /* Ajuste da altura para incluir versão */
        overflow: hidden auto;
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.35) transparent;
        transition: opacity 0.14s ease;
    }

    #menu-footer {
        position: absolute;
        display: block;
        width: 100%;
        bottom: 60px; /* Empurra o botão de logout para cima */
        transition: opacity 0.14s ease;
        
        .button {
            height: auto;
            display: block;
            padding: 4px 0;
            font-size: 0.9rem;
            border-radius: 8px;
            margin: 0 6px;
            transition: background-color 0.18s ease, color 0.18s ease;

            .icon {
                color: @vermelho;
                margin-right: 4px;
            }

            &:hover {
                .icon {
                    color: white;
                }

                background-color: #8a0b25;
            }
        }
    }

    .button-content {
        display: table;
        margin: auto;
        div {
            display: block;
        }
    }

    .button {
        display: flex;
        .clicavel;
        background-color: transparent;
        box-shadow: none;
        text-align: center;
        border: none;
        color: #c1c6df;
        padding: 0;
        height: 65px;
        margin: 0 6px 8px;
        border-radius: 10px;
        position: relative;
        transition: transform 0.16s ease, background-color 0.16s ease, color 0.16s ease;

        &:before {
            content: '';
            position: absolute;
            left: -3px;
            top: 10px;
            bottom: 10px;
            width: 3px;
            border-radius: 6px;
            background: transparent;
            transition: background-color 0.16s ease;
        }

        &:hover {
            color: white;
            background-color: rgba(255, 255, 255, 0.1);
            transform: translateY(-1px);
        }

        &.active {
            color: white;
            background: linear-gradient(160deg, #dc143c 0%, #b30f30 100%);
            box-shadow: 0 5px 14px rgba(150, 12, 43, 0.45);

            &:before {
                background: #ffffff;
            }
        }

        .button-icon {
            font-size: 1.5rem;
        }

        .button-label {
            font-size: 11px;
            max-width: 99.4%;
            text-align: center;
            margin: auto;
        }
    }

    .poweredBy {
        display: block;
        position: absolute;
        bottom: 30px; /* Ajuste para acomodar versão abaixo */
        left: 5px;
        right: 5px;
        max-width: calc(100% - 5px);
        opacity: 0.9;
        transition: opacity 0.14s ease;
    }

    .app-version {
        position: absolute;
        bottom: 5px; /* Logo abaixo de "powered by" */
        left: 5px;
        right: 5px;
        text-align: center;
        font-size: 0.75rem;
        color: white;
        opacity: 0.8; /* Deixa o texto levemente menos destacado */
        letter-spacing: 0.4px;
        transition: opacity 0.14s ease;
    }

    @media (max-height: 760px) {
        #menu-header {
            margin-top: 10px;

            .logo-container-container {
                height: 54px;

                .logo-container {
                    .logo {
                        width: 44px;
                        height: 44px;
                    }
                }
            }
        }

        #menu-screen-list {
            height: calc(100vh - 196px);
        }

        .button {
            height: 56px;
            margin-bottom: 3px;

            .button-icon {
                font-size: 1.3rem;
            }

            .button-label {
                font-size: 10px;
            }
        }

        #menu-footer {
            .button {
                font-size: 0.8rem;
                padding: 3px 0;
            }
        }
    }
}
</style>
